import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Select from '@/components/ui/Select';
import Image from '@/components/AppImage';

const JobCard = ({ job, onStatusChange, onClickView, getStatusConfig }) => {
const [isAutoApplyEnabled, setIsAutoApplyEnabled] = useState(job?.autoApplyEnabled || false);



const getMatchColor = (status) => {
if (status === 'pending') return 'text-yellow-800 bg-yellow-100';
if (status === 'shortlisted') return 'text-blue-800 bg-blue-100';
if (status === 'upper_round') return 'text-purple-800 bg-purple-100';
if (status === 'offer') return 'text-green-800 bg-green-100';
if (status === 'rejected') return 'text-red-800 bg-red-100';
return 'text-text-secondary bg-muted';
};

const formatSalary = (range, currency = 'USD') => {
if (!range) return 'Not specified';
const [min, max] = range.split('-').map(n => parseInt(n));
const format = (value) => {
if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
if (value >= 1_000) return `${(value / 1_000).toFixed(0)}k`;
return `${value}`;
};
return `${currency} ${format(min)} - ${format(max)}`;
};

const formatDate = (dateString) => {
const date = new Date(dateString);
const now = new Date();
const diffTime = Math.abs(now - date);
const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

if (diffDays === 1) return '1 day ago';
if (diffDays < 7) return `${diffDays} days ago`;
if (diffDays < 30) return `${Math.ceil(diffDays / 7)} weeks ago`;
return date?.toLocaleDateString();
};

return (
<div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 spring-transition">
{/* Header */}
<div className="flex items-start justify-between mb-4">
<div className="flex items-start space-x-3 flex-1">
<div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
<Image 
src={job?.companyLogo} 
alt={`${job?.company} logo`}
className="w-full h-full object-cover"
/>
</div>
<div onClick={() => onClickView(job)} className="flex-1 cursor-pointer min-w-0">
<h3 className="text-lg font-semibold text-text-primary mb-1 line-clamp-2">
{job?.jobTitle}
</h3>
<p  className="text-text-secondary  font-medium mb-1">{job?.company}</p>
<div className="flex items-center text-sm text-text-secondary space-x-4">

<div className="flex items-center space-x-1">
<Icon name="MapPin" size={14} />
<span>{job?.location}</span>
</div>
<div> | </div>
<div className="flex items-center space-x-1">
<Icon name="Send" size={14} />
<span className="text-gray-600">Applied:</span>
<span>{formatDate(job?.appliedDate)}</span>
</div>

<div className="flex items-center space-x-1">
<Icon name="Watch" size={14} />
<span className="text-gray-600">Deadline:</span>
<span>{formatDate(job?.deadline)}</span>
</div>

</div>
</div>
</div>

{/* Status */}
<div className={`px-3 py-1 rounded-full flex items-center gap-1 text-sm capitalize font-medium ${getStatusConfig(job?.status).color}`}>
{React.createElement(getStatusConfig(job?.status).icon, { className: "w-4 h-4" })}
{getStatusConfig(job?.status).label}
</div>
</div>

{/* Job Details */}
<div className="mb-4">
<div className="flex items-center space-x-2 text-sm mb-2">

<div className="flex items-center space-x-1 text-text-secondary">
<Icon name="DollarSign" size={14} />
<span>{formatSalary(job?.salary)}</span>
</div>
<div> | </div>
<div className="flex items-center capitalize space-x-1 text-text-secondary">
<Icon name="Briefcase" size={14} />
<span>{job?.jobType}</span>
</div>
</div>

{/* Job Description Preview */}
<p className="text-sm text-text-secondary line-clamp-2 mb-3">
{/*{job?.description}*/}
</p>

{/* Skills/Tags */}
<div className="flex flex-wrap gap-2 mb-4">
{job?.skills?.slice(0, 4)?.map((skill, index) => (
<span 
key={index}
className="px-2 py-1 bg-muted text-text-secondary text-xs rounded-md"
>
{skill}
</span>
))}
{job?.skills?.length > 4 && (
<span className="px-2 py-1 bg-muted text-text-secondary text-xs rounded-md">
+{job?.skills?.length - 4} more
</span>
)}
</div>
</div>


{/* Actions */}
<div className="flex items-center justify-between pt-4 border-t border-border">
<div className="flex items-center space-x-3">
</div>

{/* View details */}
<div className="flex items-center space-x-2">

<Button
variant="outline"
size="sm"
iconName="Eye"
iconPosition="left"
iconSize={16}
onClick={() => onClickView(job)}
>
View Details
</Button>

</div>
</div>

</div>
);
};

export default JobCard;